// Versione "lite" del Tournament live per la home di gojjobet (logica jamibet, template lite).
import {h, Fragment} from "preact";
import {route} from "preact-router";
import Ticket from "../../jamibet/utils/ticket-logic.jsx";

import * as T from "./templates-tournament.jsx";
import { RegionFlagIcon } from "../../jamibet/desktop-templates/prematch-menu.jsx";

import { Tournament as AwrabetTournament } from "../../awrabet/mobile-pages/live.jsx";

export class Tournament extends AwrabetTournament {
	bestMarketCriteria(eventsLength, validStuff) {
		if (eventsLength == 1)
			return validStuff[0];
		if (validStuff[0] && Object.keys(validStuff[0].sub).length == 3)
			return validStuff[0];
		return validStuff[1] || validStuff[0];
	}
	outcomesList(events) {
		if (events.length == 0)
			return [];
		const validStuff = events.flatMap(event => Object.values(event.sub).filter(market => Object.keys(market.sub).length <= 3))
			.sort((a, b) => a.order - b.order);
		const bestMarket = this.bestMarketCriteria(events.length, validStuff);
		if (!bestMarket)
			return [];
		const outcomesListFromMarket = Object.values(bestMarket.sub).map(outcome => ({
			id: outcome.id.split('/').slice(-2).join('.'),
			name: outcome.name
		}))
		return outcomesListFromMarket;
	}
	getOddFromEvent(event, outcomeRule) {
		const [mId, oId] = outcomeRule.id.split('.');
		const eventId = event.id.split('/').slice(-1)[0];
		return event.sub && event.sub['/market/'+eventId+'/'+mId] && event.sub['/market/'+eventId+'/'+mId].sub['/odd/'+eventId+'/'+mId+'/'+oId];
	}

	render({tournament}) {
		const oddsRule = this.outcomesList(Object.values(tournament.sub));

		return <Fragment>
			<T.TournamentDatesHeader>
				<RegionFlagIcon category={tournament.category} />
				<T.TournamentDate>{tournament.name}</T.TournamentDate>
				{oddsRule.map(outcome => <T.OutcomeNameHeader>{outcome.name}</T.OutcomeNameHeader>)}
			</T.TournamentDatesHeader>
			{Object.values(tournament.sub).sort((a, b) => a.date - b.date).map(event => <T.MatchRow key={event.id}>
				<T.MatchInfo onClick={() => {route('/live'+event.id)}}>
					<T.Teams>
						<T.TeamWithScore>
							<T.HomeTeamName>{event.home}</T.HomeTeamName>
							<T.ScoreElement>{event.current.result[0]}</T.ScoreElement>
						</T.TeamWithScore>
						<T.TeamWithScore>
							<T.AwayTeamName>{event.away}</T.AwayTeamName>
							<T.ScoreElement>{event.current.result[1]}</T.ScoreElement>
						</T.TeamWithScore>
					</T.Teams>
					<T.MatchTime>{event.status.phase}{event.status.timer ? ' - ' + event.status.timer + "'" : ''}</T.MatchTime>
				</T.MatchInfo>
				{oddsRule.length == 0
					? <EmptyOddTrio />
					: oddsRule.map(outcomeRule => <EasyOutcome outcome={this.getOddFromEvent(event, outcomeRule)} />)}
				<T.StarCell>Fv</T.StarCell>
			</T.MatchRow>)}
		</Fragment>
	}
}

export function EmptyOddTrio() {
	return <>
		<EasyOutcome outcome={null} />
		<EasyOutcome outcome={null} />
		<EasyOutcome outcome={null} />
	</>
}

function EasyOutcome({outcome}) {
	return <T.OddButtonCell>
		<T.OddButton
			value={outcome && outcome.value}
			active={outcome == null ? false : true}
			selected={outcome && Ticket.hasLiveOdds(outcome.id)}
			onClick={() => Ticket.toggleLiveOdds(outcome.id)}
			useLock={true}
			/>
	</T.OddButtonCell>
}
